module.exports = __webpack_public_path__ + "img/code-min.91159430.png";